import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import DataMap from 'components/DataMap/DataMap';
import { useMapInfoContext } from 'components/DataMap/MapInfoProvider';

const mapBoundsPadding = 48;
const maxFitBoundsZoom = 17;

const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '500px',
    maxHeight: '800px',
    marginTop: '30px',
  },
}));

export const getCampaignFarmData = (campaign) => {
  const eventData = campaign?.subscribedEvents ?? [];

  return {
    eventData,
    zipcodes: [...new Set(eventData.map(({ siteAddress }) => siteAddress.zipcode))],
  };
};

const CampaignFarmMap = ({ campaign }) => {
  const classes = useStyles();
  const { mapInstance } = useMapInfoContext();
  const { eventData, zipcodes } = React.useMemo(() => getCampaignFarmData(campaign), [campaign]);

  React.useEffect(() => {
    if (!mapInstance || eventData.length === 0) return undefined;

    const bounds = new window.google.maps.LatLngBounds();
    eventData.forEach(({ siteLocation: { coordinates } }) => {
      bounds.extend({ lat: coordinates[1], lng: coordinates[0] });
    });

    mapInstance.fitBounds(bounds, mapBoundsPadding);

    // Google Maps can zoom in excessively when a campaign has only one property
    // or a very tightly grouped farm area.
    const idleListener = window.google.maps.event.addListenerOnce(mapInstance, 'idle', () => {
      if (mapInstance.getZoom() > maxFitBoundsZoom) {
        mapInstance.setZoom(maxFitBoundsZoom);
      }
    });

    return () => window.google.maps.event.removeListener(idleListener);
  }, [eventData, mapInstance]);

  return (
    <div className={classes.root}>
      <DataMap
        highlightZipcodes={zipcodes}
        highlightEventData={eventData}
        enableEventDataDetails
        showOnlyHighlightedZipcodes
      />
    </div>
  );
};

export default CampaignFarmMap;
